import { OriginalEctlRecordType } from '@atlassiansox/bxpkit-ectl-record';
import FeatureGates from '@atlassian/feature-gate-js-client';

export function sortOutRecords(
  ectlRecords: OriginalEctlRecordType[],
  isBitbucketEnabled = false
) {
  type SortedOutRecordType = {
    jiraEligRecords: OriginalEctlRecordType[];
    jsdEligRecords: OriginalEctlRecordType[];
    jsmEligRecords: OriginalEctlRecordType[];
    confEligRecords: OriginalEctlRecordType[];
    bitbucketEligRecords: OriginalEctlRecordType[];
    jiraClaimedRecords: OriginalEctlRecordType[];
    jsdClaimedRecords: OriginalEctlRecordType[];
    jsmClaimedRecords: OriginalEctlRecordType[];
    confClaimedRecords: OriginalEctlRecordType[];
    bitbucketClaimedRecords: OriginalEctlRecordType[];
  };

  const sortedOutRecords: SortedOutRecordType = {
    jiraEligRecords: [],
    jsdEligRecords: [],
    jsmEligRecords: [],
    confEligRecords: [],
    bitbucketEligRecords: [],
    jiraClaimedRecords: [],
    jsdClaimedRecords: [],
    jsmClaimedRecords: [],
    confClaimedRecords: [],
    bitbucketClaimedRecords: []
  };

  const gate: boolean =
    FeatureGates.checkGate('bitbucket-cloud-migration-ui') ||
    isBitbucketEnabled;

  // TODO: post-MVP, look into moving below logic to a business layer (if one exists ?)

  // Eligible ----------------
  sortedOutRecords.jiraEligRecords = ectlRecords.filter((elem) =>
    elem.name.match(/^([ ]{0,}jira[ ]{1,}software[ ]{0,})/gi) &&
    !elem.ectlExpirationDate &&
    elem.available
      ? elem
      : null
  );
  sortedOutRecords.jsdEligRecords = ectlRecords.filter((elem) =>
    elem.name.match(/^([ ]{0,}jira[ ]{1,}service[ ]{1,}desk[ ]{0,})/gi) &&
    !elem.ectlExpirationDate &&
    elem.available
      ? elem
      : null
  );

  sortedOutRecords.jsmEligRecords = ectlRecords.filter((elem) =>
    elem.name.match(/^([ ]{0,}jira[ ]{1,}service[ ]{1,}management[ ]{0,})/gi) &&
    !elem.ectlExpirationDate &&
    elem.available
      ? elem
      : null
  );

  sortedOutRecords.confEligRecords = ectlRecords.filter((elem) =>
    elem.name.match(/^([ ]{0,}confluence[ ]{0,})/gi) &&
    !elem.ectlExpirationDate &&
    elem.available
      ? elem
      : null
  );

  if (gate) {
    sortedOutRecords.bitbucketEligRecords = ectlRecords.filter((elem) =>
      elem.name.match(/^([ ]{0,}bitbucket[ ]{0,})/gi) &&
      !elem.ectlExpirationDate &&
      elem.available
        ? elem
        : null
    );
  }

  // Claimed ----------------
  sortedOutRecords.jiraClaimedRecords = ectlRecords.filter((elem) =>
    elem.name.match(/^([ ]{0,}jira[ ]{1,}software[ ]{0,})/gi) &&
    elem.ectlExpirationDate
      ? elem
      : null
  );
  sortedOutRecords.jsdClaimedRecords = ectlRecords.filter((elem) =>
    elem.name.match(/^([ ]{0,}jira[ ]{1,}service[ ]{1,}desk[ ]{0,})/gi) &&
    elem.ectlExpirationDate
      ? elem
      : null
  );
  sortedOutRecords.jsmClaimedRecords = ectlRecords.filter((elem) =>
    elem.name.match(/^([ ]{0,}jira[ ]{1,}service[ ]{1,}management[ ]{0,})/gi) &&
    elem.ectlExpirationDate
      ? elem
      : null
  );
  sortedOutRecords.confClaimedRecords = ectlRecords.filter((elem) =>
    elem.name.match(/^([ ]{0,}confluence[ ]{0,})/gi) && elem.ectlExpirationDate
      ? elem
      : null
  );

  if (gate) {
    sortedOutRecords.bitbucketClaimedRecords = ectlRecords.filter((elem) =>
      elem.name.match(/^([ ]{0,}bitbucket[ ]{0,})/gi) && elem.ectlExpirationDate
        ? elem
        : null
    );
  }

  return sortedOutRecords;
}
